import type {Icon} from '@primer/octicons-react'
import {
  GitMergeIcon,
  GitMergeQueueIcon,
  GitPullRequestClosedIcon,
  GitPullRequestDraftIcon,
  GitPullRequestIcon,
  IssueClosedIcon,
  IssueOpenedIcon,
  SkipIcon,
} from '@primer/octicons-react'

export type SourceIconType = {color: string; icon: Icon}

export const PullRequestStateIcons = {
  MERGED: {
    color: 'done.fg',
    icon: GitMergeIcon,
  },
  IN_MERGE_QUEUE: {
    color: 'attention.fg',
    icon: GitMergeQueueIcon,
  },
  OPEN: {
    color: 'open.fg',
    icon: GitPullRequestIcon,
  },
  CLOSED: {
    color: 'closed.fg',
    icon: GitPullRequestClosedIcon,
  },
  DRAFT: {
    color: 'fg.muted',
    icon: GitPullRequestDraftIcon,
  },
} as const satisfies Record<string, SourceIconType>

export const IssueStateIcons = {
  OPEN: {
    color: 'open.fg',
    icon: IssueOpenedIcon,
  },
  COMPLETED: {
    color: 'done.fg',
    icon: IssueClosedIcon,
  },
  NOT_PLANNED: {
    color: 'fg.muted',
    icon: SkipIcon,
  },
} as const satisfies Record<string, SourceIconType>
